import React, { CSSProperties, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import Style from "./languageMenu.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../reducers";
import {changeTicketLanguage} from "../actions/ticket";

interface LanguageMenuProps {
  style?: CSSProperties | undefined;
  closeMenu: () => void;
  changeLanguageLabel: (lan: string) => void;
  availableLanguages: string[];
}

const LanguageMenu = (props: LanguageMenuProps) => {
  const { i18n } = useTranslation();
  const ticket = useSelector((state: RootState) => state.ticket.ticket);
  const dispatch = useDispatch();

    const handleClick = (lang: string) => {
    i18n.changeLanguage(lang);
      if (["en", "de", "fr", "it"].includes(lang) && ticket?.documentLanguage && ticket.documentLanguage?.toLowerCase() !== lang) {
        if (lang !== "en") {
          dispatch(changeTicketLanguage(ticket.number, lang));
        } else {
          dispatch(changeTicketLanguage(ticket.number, "de"));
        }
      }
  };

  return (
      <div className={isMobile ? Style.languageMenuMobile : Style.languageMenuDesktop} style={props.style}>
        {props.availableLanguages.map((lang) => (
          <div
            key={lang}
            className={Style.language}
            onClick={() => {
              handleClick(lang);
              props.closeMenu();
              props.changeLanguageLabel(lang.toUpperCase());
              localStorage.setItem("beppoSelectedLanguage", lang);
            }}
          >
            {lang.toUpperCase()}
          </div>
        ))}
      </div>
    );
  };

export default LanguageMenu;
